export default {
  GETTERS: {
    GET_ACTIVE_PRODUCT: 'PRODUCT_VARIATIONS/GET_ACTIVE_PRODUCT',
    GET_SELECTED_VARIATION: 'PRODUCT_VARIATIONS/GET_SELECTED_VARIATION',
    GET_VARIATIONS_ORIGIN: 'PRODUCT_VARIATIONS/GET_VARIATIONS_ORIGIN',
    GET_IS_PRODUCT_VARIATIONS_VISIBLE: 'PRODUCT_VARIATIONS/GET_IS_PRODUCT_VARIATIONS_VISIBLE'
  },
  MUTATIONS: {
    SET_ACTIVE_PRODUCT: 'PRODUCT_VARIATIONS/SET_ACTIVE_PRODUCT',
    SET_SELECTED_VARIATION: 'PRODUCT_VARIATIONS/SET_SELECTED_VARIATION',
    SET_VARIATIONS_ORIGIN: 'PRODUCT_VARIATIONS/SET_VARIATIONS_ORIGIN',
    SET_IS_PRODUCT_VARIATIONS_VISIBLE: 'PRODUCT_VARIATIONS/SET_IS_PRODUCT_VARIATIONS_VISIBLE'
  },
  ACTIONS: {
    TOGGLE_PRODUCT_VARIATIONS: 'PRODUCT_VARIATIONS/TOGGLE_PRODUCT_VARIATIONS'
  }
}
